<img src='assets/images/page-not-found.png' />

<h2>{{ message }}</h2>